/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_Point_0_TextInputs */

const en_visa_eb4_point_0_text = /** @type {(inputs: Visa_Eb4_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EB-4 includes several distinct classifications, each with its own rules, documentary standards, and filing considerations.`)
};

const pt_visa_eb4_point_0_text = /** @type {(inputs: Visa_Eb4_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O EB-4 inclui várias classificações distintas, cada uma com suas próprias regras, padrões documentais e considerações de apresentação.`)
};

const es_visa_eb4_point_0_text = /** @type {(inputs: Visa_Eb4_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El EB-4 incluye varias clasificaciones distintas, cada una con sus propias reglas, estándares documentales y consideraciones de presentación.`)
};

/**
* | output |
* | --- |
* | "EB-4 includes several distinct classifications, each with its own rules, documentary standards, and filing considerations." |
*
* @param {Visa_Eb4_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_point_0_text = /** @type {((inputs?: Visa_Eb4_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_point_0_text(inputs)
	if (locale === "es") return es_visa_eb4_point_0_text(inputs)
	return en_visa_eb4_point_0_text(inputs)
});